<template>
  <div class="flex flex-wrap">
    <div class="flex w-full">
      <div class="w-1/3">
        <p class="font-bold">
          {{ $t('message.documentDetail.commons.cuil') }}
        </p>
      </div>
      <div class="w-1/3">
        <p class="font-bold">
          {{ $t('message.documentDetail.informationFile.type') }}
        </p>
      </div>
      <div class="w-1/3">
        <p class="font-bold">
          {{ $t('message.documentDetail.informationFile.detail') }}
        </p>
      </div>
    </div>
    <div class="flex w-full pb-4" v-for="file in fileData">
      <div class="w-1/3">
        <p>{{ file.cuil }}</p>
      </div>
      <div class="w-1/3">
        <p>{{ file.type }}</p>
      </div>
      <div class="w-1/3">
        <p>{{ file.detail }}</p>
      </div>
    </div>
  </div>
</template>

<script>
const mockFileData = [
  {
    cuil: 27400110420,
    type: "Recibo",
    detail: "Detalle del documento",
  },
  {
    cuil: 27400110421,
    type: "Recibo",
    detail: "Detalle del documento",
  },
  {
    cuil: 27400110422,
    type: "Recibo",
    detail: "Detalle del documento",
  },
];
export default {
  name: "File",
  data() {
    return {
      fileData: mockFileData,
    };
  },
};
</script>

<style scoped></style>
